<!--Stats and Option Selector-->
<div class="lock-to-top" style="background-color: #ffffff; margin-bottom: 25px; margin-top: 0">
	<div class="date-body">
		<div class="selector-body">
			<div class="selector-item" style="display: flex">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="StartDate"
						(ngModelChange)="onStartDateChange($event)"
						name="StartDate"
					></p-calendar>
				</div>
			</div>

			<div class="selector-item" style="display: flex">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="EndDate"
						(ngModelChange)="onEndDateChange($event)"
						name="EndDate"
					></p-calendar>
				</div>
			</div>

			<div class="selector-item">
				<div>
					<label>View</label>
				</div>

				<div style="margin-left: 10px">
					<select
						class="form-control"
						name="DataTypeSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedDataType"
						(ngModelChange)="onDataTypeChange($event)"
					>
						<option *ngFor="let r of lstDataType" [ngValue]="r">
							{{ r.Desc }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</div>

	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>

	<div class="total-body">
		<div *ngIf="LoadingData == false" class="StatsGrid" style="margin-left: 20px; margin-right: 20px; padding-bottom: 5px">
			<div>
				<label>Present:</label>
				<label class="statcount">{{ PresentCount }}</label>
				<label class="statpct">({{ PresentPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Absences:</label>
				<label class="statcount">{{ AbsenceCount }}</label>
				<label class="statpct">({{ AbsenceCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Tardies:</label>
				<label class="statcount">{{ TardyCount }}</label>
				<label class="statpct">({{ TardyCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Partial Present:</label>
				<label class="statcount">{{ PartialPresent }}</label>
				<label class="statpct">({{ PartialPresentPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Excused Absences:</label>
				<label class="statcount">{{ ExcusedAbsenceCount }}</label>
				<label class="statpct">({{ ExcusedAbsenceCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Excused Tardies:</label>
				<label class="statcount">{{ ExcusedTardyCount }}</label>
				<label class="statpct">({{ ExcusedTardyCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Total Days:</label>
				<label class="statcount">{{ TotalDays }}</label>
				<label></label>
			</div>

			<div>
				<label>Days With Attendance Records:</label>
				<label class="statcount">{{ EnteredDays }}</label>
				<label class="statpct">({{ EnteredDaysPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Days Missing Attendance Records:</label>
				<label class="statcount">{{ MissingDays }}</label>
				<label class="statpct">({{ MissingDaysPCT | number : "1.0-2" }}%)</label>
			</div>
		</div>

		<div *ngIf="LoadingData == true" style="padding: 5px 10px 5px 10px">
			<div class="alert alert-info">
				<label>Loading...</label>
			</div>
		</div>
	</div>
</div>

<!--Display Table (Attendance or Timestamp)-->
<caass-attendance-info
	*ngIf="SelectedDataType.ID == 1"
	[Person]="SelectedPerson"
	[StartDate]="StartDate"
	[EndDate]="EndDate"
	(AttendanceSelected)="onAttendanceSelected($event)"
	(AttendanceChanged)="onAttendanceChanged()"
>
</caass-attendance-info>

<caass-attendance-history *ngIf="SelectedDataType.ID == 1" [SelectedAttendance]="SelectedAttendance" [SchoolID]="SchoolID"> </caass-attendance-history>

<caass-timescan-info *ngIf="SelectedDataType.ID == 2" [Person]="SelectedPerson" [StartDate]="StartDate" [EndDate]="EndDate"> </caass-timescan-info>
